"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _updateChild = _interopRequireDefault(require("./updateChild"));

var _updateChildKeys = _interopRequireDefault(require("./updateChildKeys"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var _default = function _default() {
  return function (parcelData) {
    if (parcelData.child) {
      return parcelData;
    }

    return (0, _pipeWith["default"])(parcelData, (0, _updateChild["default"])(), (0, _updateChildKeys["default"])());
  };
};

exports["default"] = _default;